import React, { useState } from "react";
import "./Cards.css";
import { useDispatch, useSelector } from "react-redux";
import { selectedItem } from "../../Redux/actions/itemsAction";
// import CustomizedDialogs from "./CustomizedDialogs";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";

function Cards(props) {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(false);

  const handleDelete = async () => {
    const url = "https://vocabulary-task.herokuapp.com/v2/delete";
    const data = await axios
      .post(url, { data: props.id })
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  const addToSelected = (e) => {
    setSelected(true);
    dispatch(
      selectedItem({
        _id: props._id,
        word: props.word,
        lexicalCategory: props.lexicalCategory,
        etymologies: props.etymologies,
        list: props.list,
        subsenseDef: props.subsenseDef,
        listtwo: props.listtwo,
        definitionData: props.definitionData,
        listthree: props.listthree,
      })
    );
  };
  return (
    <div className="list__item">
      <div className="list__word" onClick={addToSelected}>
        <h2>{props.word}</h2>
        <p>{props.definitions}</p>
      </div>
      <div className="icon__button">
        <IconButton>
          <DeleteIcon className="icon__button" onClick={handleDelete} />
        </IconButton>
      </div>
      <hr />
    </div>
  );
}

export default Cards;
